import firebase from 'firebase/app'

export const fetchUsers = async () => {
  try{
    const  querySnapshot = await firebase.firestore().collection('Users').get()
    const users = querySnapshot.docs.map((doc) => {
      return {...doc.data(), id:doc.id}
    })
   return {data: users}
  }
  catch(error){
   return {isError: true}
  }
}

export const addUser = async (user) => {
  try {
    const documentRef = await firebase.firestore().collection('Users').add(user)
    const userData = await fetchSingleUser(user.email)
    if(userData.data){
    
      return {data: {...userData.data, id:documentRef.id}}
    }else{
      return {isError: true}
    }
  }
  catch(error){
    console.log(error.message)
    return {isError: true}
  }
}
export const updateUser = async (user) => {
  try{
    await firebase.firestore().collection('Users').doc(user.id).update(user)
    return {data:true}
  }catch(error){
    return {isError: true}
  }
}

export const fetchSingleUser = async (email) => {
  console.log(email);
  try{
    const docSnapshot = await firebase.firestore().collection('Users').where('email', '==', email).get();
    console.log(docSnapshot.docs)
    return {data: docSnapshot.docs[0].data()}
  }
  catch(error){
    console.log(error.message)
    return {isError: true}
  }
}


export const deleteUser = async (id) => {
  try {
    await firebase.firestore().collection('Users').doc(id).delete()  
    return {data:id}
  } 
  catch(error){
    return {isError: true}
  }
}

export const  getMany = (ids) => {
  return Promise.all(ids.map(id => firebase.firestore().collection('Users').doc(id).get()))
}
 